import { isEmpty } from 'lodash-es';
import { IConsultant, ISMTPAccountsResponse, IUserDTO } from 'wisestep-api';

import { useUserContext, useWorkspaceContext } from '../../../context';

const ActiveConsultantsTemplate = (
  defaultAccounts: ISMTPAccountsResponse[],
  consultant?: IConsultant
) => {
  let emailContent = '';
  const currentRecruiter = useUserContext().userDTO as IUserDTO;
  const workspace = useWorkspaceContext();

  if (!isEmpty(defaultAccounts)) {
    const selectedAccount = defaultAccounts[0];
    const signature = isEmpty(selectedAccount.signatureText) ? '' : selectedAccount.signatureText;
    let body = '<p>Hi,</p>';
    const recruiterName =
      currentRecruiter.firstName || currentRecruiter.lastName
        ? currentRecruiter.firstName + ' ' + currentRecruiter.lastName
        : currentRecruiter.email;
    body +=
      '<p>My name is ' +
      recruiterName +
      ' from ' +
      workspace.name +
      '.</p><p>I am hiring for a few open roles.</p>';
    let skillText = '';

    skillText = ' with ';
    if (!isEmpty(consultant?.jobTitle)) {
      skillText += consultant?.jobTitle;
      if (consultant?.skills && consultant.skills.length > 0) {
        skillText += ', ';
      }
    }
    if (!isEmpty(consultant?.skills)) {
      const skills = consultant?.skills.map(function (skill) {
        return skill.skill;
      });
      skillText += skills?.join(', ');
    }

    body +=
      '<p>Can you please email me the resumes of your bench consultants' + skillText + '?</p>';
    body +=
      '<p>Alternately, you can also contact me on ' +
      (currentRecruiter.phoneNumber ? currentRecruiter.phoneNumber : currentRecruiter.email) +
      '</p>';
    body += '<p>Regards</p><p>' + recruiterName + '</p>';

    emailContent += body + '<br>' + signature;
  }
  return emailContent;
};

export default ActiveConsultantsTemplate;
